export default __webpack_public_path__ + "static/media/bedroom2.df35dbfa.png";